import React,{forwardRef} from 'react'
import AttributeForm from './AttributeForm';

const AddAttribute = forwardRef((props, ref) => {
    const {
        formValidateError,
        attributeFormSave,
        updateAttributeState,
        isButtonLoader
    } = props;
    return (
        <>
            <AttributeForm
                formValidateError={formValidateError}
                attributeFormSave={attributeFormSave}
                updateAttributeState={updateAttributeState}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})

export default AddAttribute